var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "white",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.2,4.8c-1.5-1.2-3.4-1.7-5.3-1.3L34.3,14.4c-3,0.6-5.2,3.2-5.2,6.3v43.3c-2.2-0.7-4.5-1.1-6.9-1.1    c-10.9,0-19.7,7.6-19.7,16.9s8.9,16.9,19.7,16.9S42,89.1,42,79.8V36.9l42.7-8.4v35.4c-2.2-0.7-4.5-1.1-6.9-1.1    C66.9,62.9,58,70.4,58,79.8s8.9,16.9,19.7,16.9s19.7-7.6,19.7-16.9v-70C97.5,7.8,96.6,6,95.2,4.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVed);
export default __webpack_public_path__ + "static/media/ved.b54c946fc203dd2f99a0c95090cfe501.svg";
export { ForwardRef as ReactComponent };